import { StringFormatterService } from "@/domain/services";

export class StringFormatter implements StringFormatterService {
  capitalizeFirst = (value: string) => {
    return value.replace(/[a-zA-Z]/, (match) => match.toUpperCase());
    // return value.charAt(0).toUpperCase() + value.slice(1);
  };
  clearSpecialChars = (value?: string): string => {
    if (!value) return "";
    return value.replace(/[^\dA-Za-z]/g, "").replace(/[_-]/g, "");
  };
}
